import cookie from "@/assets/js/components/cookie";

const TOKEN_KEY = 'access_token';
const MANAGER_TOKEN_KEY = 'manager_access_token';

const storage = {
    type: 'cookie',
    local() {
        this.type = 'local'
        return this
    },
    cookie() {
        this.type = 'cookie';
        return this;
    },

    get(key) {
        if (this.type === 'local') {
            return localStorage.getItem(key);
        } else {
            return cookie.getCookie(key);
        }
    },
    set(key, value) {
        if (this.type === 'local') {
            localStorage.setItem(key, value);
        } else {
            cookie.setCookie(key, value);
        }
    },
    remove(key) {
        if (this.type === 'local') {
            localStorage.removeItem(key);
        } else {
            cookie.deleteCookie(key);
        }
    },
    getAndRemove(key) {
        let data = this.get(key)
        this.remove(key)
        if (data) {
            return data
        }
        return null;
    },
    getToken() {
        let managerToken = this.get(MANAGER_TOKEN_KEY)
        if (managerToken) {
            return managerToken;
        }
        return this.get(TOKEN_KEY)
     },
};

export default storage;
